import Api from '@/services/Api'
import axios from 'axios'

export default {
  getV2() {
    return Api().get('v2/production')
  },
  getV3() {
    return Api().get('v3/production')
  },

  getV2Analytics(date) {
    return Api().post('v2/analytics', {date: date})
  },

  getItem(name) {
    return Api().get(`production/${name}`);
  },
 
  createShipping(name) {
    return Api().post(`createShipping/${name}`);
  },
  generateBabyCube(page) {
    return Api().get(`/plugin/babycube/generate?page=${page}`);
  },
  generateDateKeychain(page) {
    return Api().get(`/plugin/datekeychain/generate?page=${page}`);
  },
  generatePhotoZippo() {
    return Api().get(`photozippo/download/now`, { timeout: 0 });
  },
  generatePhotoKeychain() {
    return Api().get(`photokeychain/download/now`, { timeout: 0 });
  },
  generatePhotoAMZKeychain() {
    return Api().get(`photoAMZkeychain/download/now`, { timeout: 0 });
  },
  generatePhotoAMZZippo() {
    return Api().get(`photoAMZzippo/download/now`, { timeout: 0 });
  },
  createDamagedItem(payload) {
    return Api().post(`damaged/product`, payload);
  },
  getDamagedHistory() {
    return Api().get("damaged/products");
  },
  applyTrash(orderId, variationId, qty) {
    return Api().post(`damaged/trash`, { orderId: orderId, variationId: variationId, qty: qty });
  },

  //v2 damaged routes
  getDamagedHistory2() {
    return Api().get("damaged/v2/history");
  },

  searchWarehouseStock(name) {
    ///damaged/v2/search
    return Api().get(`damaged/v2/search?q=${name}`);
  },

  //create damaged item
  createDamagedItem2(payload) {
    return Api().post(`damaged/v2/product`, payload);
  },

  createPacklist(name) {
    return Api().post(`packlist/${name}`);
  },

  getRetoureHistory() {
    return Api().get("retoure");
  },
  createRetoure(payload) {
    return Api().post(`retoure`, payload);
  },
  getRetoureShelf() {
    return Api().get("retoure/shelf");
  },
  updateRetoure(payload, billbee) {
    return Api().post(`retoure/update/${payload.retoure.id}?billbee=${billbee}`, payload);
  },
  loadOrderData(orderId) {
    return Api().post(`retoure/loadOrderData`, { orderId: orderId });
  },
  searchOrderByTracking(trackingId) {
    return Api().post("retoure/searchByTracking", { trackingId: trackingId });
  },

  reShipRetoure(orderId, payload) {
    return Api().post(`retoure/ship/${encodeURIComponent(orderId)}`, payload);
  },

  markAsShipped(orderId, table) {
    return Api().post(`reproduction/markAsShipped`, { orderId: orderId, table: table });
  },

  searchOrder(searchTerm) {
    return Api().get("search?q=" + encodeURIComponent(searchTerm))
  },

  searchCustom(searchTerm) {
    return Api().post("searchCustom", { query: searchTerm })
  },

  resetOrder(orderId) {
    return Api().post(`resetOrder/${encodeURIComponent(orderId)}`);
  },

  getOrder(orderId) {
    return Api().get(`order/${encodeURIComponent(orderId)}`);
  },

  getOrderByInternalId(managedId) {
    return Api().get(`order/internal/${encodeURIComponent(managedId)}`);
  },

  getMongoOrder(orderId) {
    return Api().get(`mongo/order/${encodeURIComponent(orderId)}`);
  },

  getTrackingState(trackingId) {
    return Api().post("trackingState", { trackingId: trackingId });
  },

  getReusableItems(sku) {
    return Api().get(`reusableItems/${sku}`)
  },

  reuseItem(id) {
    return Api().post(`reusableItems/${id}`)
  },

  updateEntry(table, item) {
    return Api().post(`update/${table}`, item)
  },

  deleteEntry(table, id) {
    return Api().delete(`/delete/${table}/${id}`)
  },

  getWarehouse() {
    return Api().get(`warehouse`)
  },

  getProductionTime(date = null) {
    return Api().get(`/controlling/productiontime/${date}`)
  },

  getProductionTimeLine(date = null) {
    return Api().get(`/controlling/productiontimeline/${date}`)
  },

  getCartons() {
    return Api().get(`cartons`)
  },

  connectCarton(cartonId, productId) {
    return Api().post(`connectCarton`, { cartonId: cartonId, productId: productId })
  },

  

  createBarcode(barcode, format) {
    return Api().get(`/plugin/barcode/${barcode}/${format}`)
  },

  createPackageList(from, to) {
    return Api().post(`/packageList`, { from: from, to: to})
  },

  uspGetArtworks() {
    return Api().get(`/plugin/usg/artworks`)
  },
  uspGenerateOrderId(orderId) {
    return Api().get(`/plugin/usg/generate/${encodeURIComponent(orderId)}`)
  },
  uspGetOrderForSku(sku) {
    return Api().get(`/plugin/usg/order/${encodeURIComponent(sku)}`)
  },

  uspUpdateArtwork(artwork) {
    return Api().post(`/plugin/usg/artworks/update`, artwork);
  },

  uspUploadArtwork(file) {
    return Api().post(`/plugin/usg/artworks/upload`, {file: file});
  },

  productionAddOrder(orderId) {
    return Api().post(`/production/add`, {orderId: orderId});
  },

  releaseState(table, id) {
    return Api().post("/production/release", { table: table, id: id});
  },

  getWarrantyReasons() {
    return Api().get("/rekla/reasons");
  },

  createRekla(data) {
    return Api().post("/rekla", data);
  },

  getReklaInformations(orderId) {
    return Api().get(`/rekla/validation/${orderId}`);
  },

  getPrinters() {
    return axios.get('/api/v2/packlist/printers/active');
  },

  printShippingLabel(data) {
    return axios.post('/api/shipping/label/print', data);
  },

  printEmbroideryLabels(orders, table) {
    return Api().post('/v2/embroidery/print-labels', { orders, table });
  },

  getEmbroideryProductionList(sku) {
    const params = sku ? `?sku=${encodeURIComponent(sku)}` : '';
    return Api().get(`/v2/embroidery/production-list${params}`);
  },
  getEmbroideryProductionListSkus() {
    return Api().get('/v2/embroidery/production-list/skus');
  },
  scanEmbroideryProductionItem(uuid, sku, scannedEan) {
    return Api().post('/v2/embroidery/production-list/scan', { uuid, sku, scannedEan });
  },
  deleteFromEmbroideryProductionList(ids) {
    return Api().delete('/v2/embroidery/production-list', { data: { ids } });
  },
  downloadEmbroideryCsv(sku) {
    return Api().get(`/v2/embroidery/csv/${encodeURIComponent(sku)}`);
  },

  getEmbroideryProducts() {
    return Api().get('/v2/embroidery/products');
  },
  createEmbroideryProduct(payload) {
    return Api().post('/v2/embroidery/products', payload);
  },
  updateEmbroideryProduct(id, payload) {
    return Api().put(`/v2/embroidery/products/${id}`, payload);
  },
  deleteEmbroideryProduct(id) {
    return Api().delete(`/v2/embroidery/products/${id}`);
  },

  getEmbroideryShelf() {
    return Api().get('/v2/embroidery/shelf');
  },
  createEmbroiderySlot(payload) {
    return Api().post('/v2/embroidery/shelf', payload);
  },
  updateEmbroiderySlot(id, payload) {
    return Api().put(`/v2/embroidery/shelf/${id}`, payload);
  },
  deleteEmbroiderySlot(id) {
    return Api().delete(`/v2/embroidery/shelf/${id}`);
  },
  bookEmbroideryStock(id, payload) {
    return Api().post(`/v2/embroidery/shelf/${id}/book`, payload);
  },
  getEmbroiderySlotLog(id) {
    return Api().get(`/v2/embroidery/shelf/${id}/log`);
  },
  printEmbroideryShelfLabel(id) {
    return Api().post(`/v2/embroidery/shelf/${id}/print`);
  },
  getEmbroiderySlotOrders(id) {
    return Api().get(`/v2/embroidery/shelf/${id}/orders`);
  },
  printAndOutEmbroidery(id, orders) {
    return Api().post(`/v2/embroidery/shelf/${id}/print-out`, { orders });
  },
  getEmbroideryNextJob() {
    return Api().get('/v2/embroidery/shelf/next-job');
  },
  getEmbroideryNextJobBySku(sku) {
    return Api().get(`/v2/embroidery/shelf/next-job-by-sku?sku=${encodeURIComponent(sku)}`);
  },
  getEmbroideryExportedItems() {
    return Api().get('/v2/embroidery/production-list/exported');
  },
  resetEmbroideryExportedItem(id) {
    return Api().delete(`/v2/embroidery/production-list/exported/${id}`);
  },
  confirmEmbroideryPickup(slotId, qty, orders) {
    return Api().post(`/v2/embroidery/shelf/${slotId}/confirm-pickup`, { qty, orders });
  },
  printSingleEmbroideryLabel(order, slotId) {
    return Api().post('/v2/embroidery/print-single-label', { order, slotId });
  },
  getEmbroideryPostProcessInfo(uuid) {
    return Api().get(`/v2/embroidery/post-process/${encodeURIComponent(uuid)}`);
  },
  createEmbroideryDummy(payload) {
    return Api().post('/v2/embroidery/production-list/dummy', payload);
  },
  getEmbroideryProducts() {
    return Api().get('/v2/embroidery/products');
  },

}